import React, { FC, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ActionsGroup,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dropdown,
  FlatButton,
  IconButton,
  RaisedButton,
} from "@evergis/ui";

import { Content } from "./styled";
import { ModalDialog } from "../DialogComponents/ModalDialog";
import { useDialogInfo } from "../../../hooks/useDialogs";
import { useProjectInfo } from "../../../ducks/project/hooks";
import { ConfigFilterDialogOptions } from "./types";

export const ConfigFilter: FC = () => {
  const { t } = useTranslation("projectConfig");
  const { options, closeDialog } = useDialogInfo<string[], ConfigFilterDialogOptions>();
  const [selectedDataSource, setSelectedDataSource] = useState<string>();
  const [{ content }] = useProjectInfo();
  const { dashboardConfiguration } = content;
  const { children, dataSources } = dashboardConfiguration;
  const { page, onPaste } = options;

  const renderOptions = useMemo(
    () =>
      (children[0].children[page - 1]?.dataSources || [])
        .concat(dataSources || [])
        .filter(Boolean)
        .map(({ name }) => ({ value: name, text: name })),
    [children, dataSources, page],
  );

  const onSelect = useCallback(values => {
    setSelectedDataSource(values[0].value);
  }, []);

  const onSubmit = useCallback(() => {
    onPaste(selectedDataSource);
    closeDialog();
  }, [closeDialog, onPaste, selectedDataSource]);

  return (
    <ModalDialog maxWidth={"40rem"}>
      <DialogTitle>
        <ActionsGroup>{t("addFilter")}</ActionsGroup>
        <ActionsGroup>
          <IconButton kind="close" onClick={closeDialog} />
        </ActionsGroup>
      </DialogTitle>
      <DialogContent>
        <Content>
          <Dropdown
            label={t("dataSource")}
            width={"33rem"}
            zIndex={120}
            placeholder={t("notChosen", { ns: "common" })}
            value={selectedDataSource}
            options={renderOptions}
            onChange={onSelect}
          />
        </Content>
      </DialogContent>
      <DialogActions>
        <ActionsGroup>
          <RaisedButton primary onClick={onSubmit}>
            {t("actions.add", { ns: "common" })}
          </RaisedButton>
          <FlatButton onClick={closeDialog}>{t("actions.cancel", { ns: "common" })}</FlatButton>
        </ActionsGroup>
      </DialogActions>
    </ModalDialog>
  );
};
